/** [r184 compat] side-effect init — use window.THREE after load */
require('./r184/base.js');

var THREE = (typeof window !== 'undefined' && window.THREE) ? window.THREE : {};

if (typeof module === 'object' && module.exports) {
  module.exports = THREE;
}
